export default __webpack_public_path__ + "images/publishIcon.svg";